module.exports = __webpack_public_path__ + "guide-service02.b2b96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/guide-service02.svg
// module id = ./src/_asset/sources/assets/images/@svg/guide-service02.svg
// module chunks = main